'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorPieChart = function EditorPieChart(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z' })
  );
};
EditorPieChart = (0, _pure2.default)(EditorPieChart);
EditorPieChart.displayName = 'EditorPieChart';
EditorPieChart.muiName = 'SvgIcon';

exports.default = EditorPieChart;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/editor/pie-chart.js
 ** module id = 1946
 ** module chunks = 0
 **/